
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "<div class=\"mt-9\">\n  <div class=\"avatar-wrapper mx-auto h-24 w-24 mobileLandscape:h-40 mobileLandscape:w-40\"></div>\n  <div class=\"my-5 text-base break-all\" id=\"prefillEmail\">{{ email }}</div>\n</div>\n"
      return mustache.render(src, view, partials);
    };
  